import { searchResultSchema, type SearchQuery, type SearchResult } from "@mailflare/shared";

import { apiRequest } from "@/lib/api-client";

export async function searchMessages(params: Partial<SearchQuery>): Promise<SearchResult> {
  return searchResultSchema.parse(await apiRequest<unknown>("/search", { query: params }));
}
